import { useQueryClient } from '@tanstack/react-query';

type updateCacheProps = {
    loanNumber: string;
    product: string;
    offerGUID?: string;
};
export const useWidgetsQueryClient = () => {
    const queryClient = useQueryClient();
    const queryKey = ['widgets'];
    const updateCache = ({ loanNumber, product, offerGUID }: updateCacheProps) => {
        queryClient.setQueryData(queryKey, (old: any) => {
            if (!old) return old;
            return {
                ...old,
                data: {
                    ...old?.data,
                    cards: old?.data?.cards.map((card: any) => {
                        if (card?.id === 'HV' && product.startsWith('HV')) {
                            const updatedInitParam = card.initParam.map((loan: any) => {
                                if (loan?.loanNumber !== loanNumber) return loan;
                                return {
                                    ...loan,
                                    predefinedCardDetails: [{ ...loan?.predefinedCardDetails[0], childProduct: undefined }]
                                };
                            });
                            return { ...card, initParam: updatedInitParam };
                        }
                        if (card?.id === 'offers') {
                            const updatedInitParam = card.initParam.map((loan: any) => {
                                if (loan?.loanNumber !== loanNumber) return loan;
                                return {
                                    ...loan,
                                    offers: loan?.offers?.filter((offer: any) => offer.product !== product)
                                };
                            });
                            return { ...card, initParam: updatedInitParam };
                        }
                        return card;
                    })
                }
            };
        });
    };
    return { updateCache };
};
